import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthPut1} from "../../../../../core/services/common/HttpRequestBuilder"


const deviceList = (parameters) => {

    let result = HttpAuthGet(routes.DEVICE_LIST, parameters);
    return result;
}

const updateDeviceStatus = (parameters) => {

    let result = HttpAuthPut(routes.UPDATE_STATUS, parameters);
    return result;
}

const updateDevice = (parameters, payload) => {

    let result = HttpAuthPut1(routes.UPDATE_DEVICE, parameters, payload);
    return result;
}

const updateEntryType = (parameters) => {

    let result = HttpAuthPut(routes.UPDATE_ENTRY_TYPE, parameters);
    return result;
}

const filterDeviceList = (parameters) => {

    let result = HttpAuthGet(routes.FILTER_DEVICE_LIST, parameters);
    return result;
}

const DeviceManagementService = {
    deviceList,
    updateDeviceStatus,
    updateDevice,
    updateEntryType,
    filterDeviceList
}

export default DeviceManagementService
